import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/aspect-ratio-calculator',
  component: () => import('../../routes/AspectRatioCalculator.svelte'),
  card: {
    id: 'aspect-ratio-calculator',
    title: 'Aspect Ratio Calculator',
    description:
      'Simplify, scale, and solve aspect ratios for photos, video, monitors, and cinema. Find the simplified W:H form, scale dimensions to a target ratio, and compute diagonals.',
    icon: 'aspect_ratio',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/aspect-ratio-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Aspect Ratio Calculator – Simplify, Scale & Solve W:H Ratios',
    description:
      'Free aspect ratio calculator: reduce W:H to its simplest form, scale dimensions to a target ratio, and compute diagonals. Includes presets for 16:9, 4:3, 21:9, 2.35:1, 9:16 and more.',
  },
};

export default meta;
